module.exports = __webpack_public_path__ + "img/123.6.0a8f2d70.png";